import React from 'react'
import { useAuth } from '../context/AuthContext'
import { Button } from '../components/common/Button'

export const LoginPage: React.FC = () => {
  const { signInWithMicrosoft, error, loading } = useAuth()

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-stone-300 via-stone-200 to-slate-300 px-4 dark:from-slate-950 dark:via-slate-900 dark:to-slate-800">
      <div className="w-full max-w-md rounded-2xl border border-stone-400 bg-stone-100 p-8 shadow-xl dark:border-slate-700 dark:bg-slate-900">
        <div className="mb-8 text-center">
          <h1 className="mb-2 text-3xl font-bold text-slate-900">iPulse Systems DoD</h1>
          <p className="text-slate-600">Internal delivery tracking and request workflow</p>
        </div>

        {error && (
          <div className="mb-4 rounded-lg border border-red-300 bg-red-100 p-4 dark:border-red-800 dark:bg-red-950/50">
            <p className="text-sm text-red-800 dark:text-red-200">{error.message}</p>
          </div>
        )}

        <Button
          onClick={() => signInWithMicrosoft()}
          isLoading={loading}
          className="w-full"
          size="lg"
        >
          Sign in with Microsoft
        </Button>

        <div className="mt-6 border-t border-stone-300 pt-6 text-center text-sm text-slate-600 dark:border-slate-700 dark:text-slate-300">
          <p>Using your Microsoft account to access iPulse Systems DoD</p>
        </div>
      </div>
    </div>
  )
}
